// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Switch_toggle__3d8_-","wrapper":"Switch_wrapper__3cqlL","label":"Switch_label__SZkOD","checked":"Switch_checked__1qTmJ"};